<template>
  <div class="controles-panel">
    <div class="panel-body">
      <div class="row g-3 align-items-start">

        <!-- Columna izquierda: tabs de búsqueda -->
        <div class="col-7">
          <div class="search-tabs">
            <button
              v-for="tab in tabs" :key="tab.key"
              class="search-tab"
              :class="{ active: tabActivo === tab.key }"
              @click="cambiarTab(tab.key)"
              type="button"
            >
              <span class="material-symbols-outlined" style="font-size:16px">{{ tab.icon }}</span>
              {{ tab.label }}
            </button>
          </div>

          <div class="search-box mt-2">
            <div class="d-flex gap-1">
              <button type="button" class="btn-reload" @click="cargarElementosActivos" title="Buscar">
                <span class="material-symbols-outlined" style="font-size:18px">search</span>
              </button>
              <div style="position:relative; flex:1;">
                <input
                  type="text"
                  class="search-input"
                  v-model="controlesFiltro"
                  :placeholder="tabActual.placeholder"
                  :disabled="controlesItems.length === 0"
                  @input="buscarEnControles"
                  @focus="mostrarDropdown = true"
                  @blur="ocultarDropdownConDelay"
                  autocomplete="off"
                />
                <div v-if="mostrarDropdown && controlesItemsFiltradosLocal.length > 0" class="search-dropdown">
                  <div
                    v-for="item in controlesItemsFiltradosLocal" :key="item.idElemento"
                    @mousedown="seleccionarControl(item)"
                    class="dropdown-item-custom"
                    :class="{ selected: controlSeleccionado?.idElemento === item.idElemento }"
                  >
                    <span class="item-code">{{ item.elementoCodigo }}</span>
                    <span class="item-sep">—</span>
                    <span class="item-name">{{ item.elementoNombre }}</span>
                  </div>
                </div>
                <div
                  v-if="mostrarDropdown && controlesFiltro && controlesItemsFiltradosLocal.length === 0 && controlesItems.length > 0"
                  class="search-dropdown no-results"
                >
                  Sin resultados para "{{ controlesFiltro }}"
                </div>
              </div>
            </div>

            <div v-if="controlSeleccionado" class="selected-item mt-2">
              <span class="material-symbols-outlined" style="font-size:15px; color:#0d6efd">check_circle</span>
              <strong>{{ controlSeleccionado.elementoCodigo }}</strong> — {{ controlSeleccionado.elementoNombre }}
            </div>

            <div class="search-status mt-1">
              <span v-if="controlesBuscando" class="text-muted">
                <span class="material-symbols-outlined spin" style="font-size:14px">progress_activity</span>
                Cargando...
              </span>
              <span v-else-if="controlesItems.length === 0" class="text-muted">
                Sin elementos disponibles — presione 🔍 para cargar
              </span>
              <span v-else class="text-muted">
                {{ controlesItems.length }} elementos disponibles
              </span>
            </div>
          </div>
        </div>

        <!-- Columna centro: calendario -->
        <div class="col-3">
          <label class="field-label">
            Fechas
            <span v-if="controlesFechasSeleccionadas.length" class="badge bg-primary ms-1" style="font-size:0.7rem">
              {{ controlesFechasSeleccionadas.length }}
            </span>
          </label>

          <div class="d-flex align-items-center gap-1 mb-1">
            <button type="button" class="btn-nav" @click="controlesMesVista = restarMes(controlesMesVista)">‹</button>
            <input
              type="month"
              class="form-control form-control-sm"
              v-model="controlesMesVista"
              :min="fechaDesde?.substring(0,7)"
              :max="fechaHasta?.substring(0,7)"
              style="width:130px; font-size:0.8rem;"
            />
            <button type="button" class="btn-nav" @click="controlesMesVista = sumarMes(controlesMesVista)">›</button>
          </div>

          <div class="calendar-wrapper">
            <div class="calendar-grid mb-1">
              <div v-for="d in ['Lu','Ma','Mi','Ju','Vi','Sá','Do']" :key="d" class="cal-header">{{ d }}</div>
            </div>
            <div class="calendar-grid">
              <div v-for="(dia, idx) in controlesDiasDelMes" :key="idx" class="cal-cell">
                <span v-if="dia.vacio"></span>
                <button
                  v-else-if="!dia.disabled"
                  type="button"
                  class="cal-btn"
                  :class="{ selected: controlesFechasSeleccionadas.includes(dia.fecha) }"
                  @click="toggleFechaControl(dia.fecha)"
                  :title="dia.fecha"
                >{{ dia.label }}</button>
                <span v-else class="cal-disabled">{{ dia.label }}</span>
              </div>
            </div>
          </div>

          <div class="d-flex gap-1 mt-2">
            <button type="button" class="btn-quick" @click="seleccionarTodosMes">Todos</button>
            <button type="button" class="btn-quick" @click="controlesFechasSeleccionadas = []">Limpiar</button>
          </div>
        </div>

        <!-- Columna derecha: acciones -->
        <div class="col-2 d-flex flex-column gap-2" style="padding-top:1.6rem;">
          <button
            type="button" class="btn-action success"
            @click="ejecutarCargar"
            :disabled="!controlSeleccionado || !controlesTieneFechas"
            title="Cargar elemento en planilla"
          >
            <span class="material-symbols-outlined">add_circle</span>
            Cargar
          </button>
          <button
            type="button" class="btn-action danger"
            @click="ejecutarAnular"
            :disabled="!controlSeleccionado || !controlesTieneFechas"
            title="Anular elemento en planilla"
          >
            <span class="material-symbols-outlined">do_not_disturb_on</span>
            Anular
          </button>
          <button
            type="button" class="btn-action secondary"
            @click="limpiar"
            title="Limpiar selección"
          >
            <span class="material-symbols-outlined">delete</span>
            Limpiar
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "RegistroPorFechas",

  props: {
    idPlanilla:  { type: [Number, String], required: true },
    idPrestador: { type: [Number, String], required: true },
    idUsuario:   { type: [Number, String], required: true },
    fechaDesde:  { type: String, required: true },
    fechaHasta:  { type: String, required: true },
  },

  emits: ["cargado", "anulado"],

  data() {
    return {
      tabActivo: "prestaciones",
      tabs: [
        { key: "prestaciones", label: "Prestaciones", icon: "medical_services", placeholder: "Buscar por código o nombre..." },
        { key: "medicamentos", label: "Medicamentos", icon: "medication",        placeholder: "Buscar medicamento..." },
        { key: "insumos",      label: "Insumos",      icon: "inventory_2",       placeholder: "Buscar insumo..." },
      ],
      controlesItems:               [],
      controlesFechasSeleccionadas: [],
      controlesMesVista:            "",
      controlesBuscando:            false,
      controlesItemsFiltradosLocal: [],
      controlesFiltro:              "",
      controlSeleccionado:          null,
      mostrarDropdown:              false,
    };
  },

  computed: {
    tabActual() {
      return this.tabs.find(t => t.key === this.tabActivo) || this.tabs[0];
    },
    controlesTieneFechas() {
      return this.controlesFechasSeleccionadas.length > 0;
    },
    controlesDiasDelMes() {
      if (!this.controlesMesVista) return [];
      const [year, month] = this.controlesMesVista.split("-").map(Number);
      const diasEnMes   = new Date(year, month, 0).getDate();
      const primerDia   = new Date(year, month - 1, 1).getDay();
      const offsetLunes = (primerDia + 6) % 7;
      const dias = [];
      for (let i = 0; i < offsetLunes; i++) dias.push({ vacio: true });
      for (let d = 1; d <= diasEnMes; d++) {
        const fecha = `${year}-${String(month).padStart(2,"0")}-${String(d).padStart(2,"0")}`;
        dias.push({
          fecha, label: d, vacio: false,
          disabled:
            (this.fechaDesde && fecha < this.fechaDesde) ||
            (this.fechaHasta && fecha > this.fechaHasta),
        });
      }
      return dias;
    },
  },

  watch: {
    fechaDesde(val) {
      if (val) this.controlesMesVista = val.substring(0, 7);
    },
  },

  mounted() {
    if (this.fechaDesde) this.controlesMesVista = this.fechaDesde.substring(0, 7);
  },

  methods: {
    cambiarTab(tab) {
      this.tabActivo = tab;
      this.limpiar();
    },

    endpointPorTab() {
      const map = {
        prestaciones: `/vwtarifapress/idprestador/${this.idPrestador}`,
        medicamentos:  `/vwtarifapress/idprestador/10`,
        insumos:       `/vwtarifapress/idprestador/11`,
      };
      return map[this.tabActivo];
    },

    ocultarDropdownConDelay() {
      setTimeout(() => { this.mostrarDropdown = false; }, 200);
    },

    async cargarElementosActivos() {
      this.controlesBuscando            = true;
      this.controlesItems               = [];
      this.controlesItemsFiltradosLocal = [];
      this.controlSeleccionado          = null;
      this.controlesFiltro              = "";
      try {
        const response = await api.get(this.endpointPorTab());
        this.controlesItems = response.data;
      } catch {
        Swal.fire("Error", "No se pudo cargar los elementos", "error");
      } finally {
        this.controlesBuscando = false;
      }
    },

    buscarEnControles() {
      this.mostrarDropdown     = true;
      this.controlSeleccionado = null;
      if (!this.controlesFiltro.trim()) {
        this.controlesItemsFiltradosLocal = [];
        return;
      }
      const filtro = this.controlesFiltro.toLowerCase();
      this.controlesItemsFiltradosLocal = this.controlesItems.filter(item =>
        (item.elementoCodigo ?? "").toLowerCase().includes(filtro) ||
        (item.elementoNombre ?? "").toLowerCase().includes(filtro)
      );
    },

    seleccionarControl(item) {
      this.controlSeleccionado = item;
      this.controlesFiltro     = item.elementoCodigo + " - " + item.elementoNombre;
      this.mostrarDropdown     = false;
    },

    toggleFechaControl(fecha) {
      const idx = this.controlesFechasSeleccionadas.indexOf(fecha);
      if (idx === -1) this.controlesFechasSeleccionadas.push(fecha);
      else            this.controlesFechasSeleccionadas.splice(idx, 1);
    },

    seleccionarTodosMes() {
      const disponibles = this.controlesDiasDelMes
        .filter(d => !d.disabled && !d.vacio)
        .map(d => d.fecha);
      const todos = disponibles.every(f => this.controlesFechasSeleccionadas.includes(f));
      if (todos) {
        this.controlesFechasSeleccionadas = this.controlesFechasSeleccionadas
          .filter(f => !disponibles.includes(f));
      } else {
        const nuevas = disponibles.filter(f => !this.controlesFechasSeleccionadas.includes(f));
        this.controlesFechasSeleccionadas.push(...nuevas);
      }
    },

    restarMes(mesVista) {
      const [y, m] = mesVista.split("-").map(Number);
      const d = new Date(y, m - 2, 1);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2,"0")}`;
    },

    sumarMes(mesVista) {
      const [y, m] = mesVista.split("-").map(Number);
      const d = new Date(y, m, 1);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2,"0")}`;
    },

    limpiar() {
      this.controlSeleccionado          = null;
      this.controlesFiltro              = "";
      this.controlesFechasSeleccionadas = [];
      this.controlesItemsFiltradosLocal = [];
      this.controlesItems               = [];
      this.mostrarDropdown              = false;
    },

    async ejecutarCargar() {
      if (!this.controlSeleccionado || !this.controlesTieneFechas) {
        Swal.fire("Atención", "Debe seleccionar un elemento y al menos una fecha", "warning");
        return;
      }
      try {
        const fechas = [...this.controlesFechasSeleccionadas].sort();
        const params = new URLSearchParams();
        params.append("idPlanilla", this.idPlanilla);
        params.append("idElemento", this.controlSeleccionado.idElemento);
        fechas.forEach(f => params.append("fechas", f));
        const response = await api.post(`/procedimientos/cargar-ele-pla-fechas?${params.toString()}`);
        Swal.fire("Éxito", response.data || "Elemento cargado exitosamente", "success");
        this.$emit("cargado");
      } catch (error) {
        Swal.fire("Error", error.response?.data || "No se pudo cargar el elemento", "error");
      }
    },

    async ejecutarAnular() {
      if (!this.controlSeleccionado || !this.controlesTieneFechas) {
        Swal.fire("Atención", "Debe seleccionar un elemento y al menos una fecha", "warning");
        return;
      }
      const confirm = await Swal.fire({
        title: "¿Confirmar anulación?",
        text: `Se anulará ${this.controlSeleccionado.elementoCodigo} en ${this.controlesFechasSeleccionadas.length} fecha(s)`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, anular",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#d33",
      });
      if (!confirm.isConfirmed) return;
      try {
        const fechas = [...this.controlesFechasSeleccionadas].sort();
        const params = new URLSearchParams();
        params.append("idPlanilla", this.idPlanilla);
        params.append("idElemento", this.controlSeleccionado.idElemento);
        fechas.forEach(f => params.append("fechas", f));
        const response = await api.post(`/procedimientos/anular-ele-pla-fechas?${params.toString()}`);
        Swal.fire("Éxito", response.data || "Elemento anulado exitosamente", "success");
        this.$emit("anulado");
      } catch (error) {
        Swal.fire("Error", error.response?.data || "No se pudo anular el elemento", "error");
      }
    },
  },
};
</script>

<style scoped>
.controles-panel {
  background: #f8f9fa;
}
.panel-body {
  padding: 14px 16px;
}
/* Tabs */
.search-tabs {
  display: flex; gap: 4px;
  border-bottom: 2px solid #dee2e6;
}
.search-tab {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 12px; border: none; background: transparent;
  font-size: 0.8rem; color: #6c757d; cursor: pointer;
  border-bottom: 2px solid transparent; margin-bottom: -2px;
  border-radius: 4px 4px 0 0; transition: all 0.15s;
}
.search-tab:hover  { background: #f0f4ff; color: #0d6efd; }
.search-tab.active { color: #0d6efd; border-bottom-color: #0d6efd; font-weight: 600; background: #fff; }
/* Search */
.search-input {
  width: 100%; padding: 6px 10px; border: 1px solid #ced4da;
  border-radius: 4px; font-size: 0.85rem; transition: border-color 0.15s;
}
.search-input:focus    { outline: none; border-color: #0d6efd; box-shadow: 0 0 0 2px rgba(13,110,253,.15); }
.search-input:disabled { background: #f8f9fa; }
.btn-reload {
  display: flex; align-items: center; justify-content: center;
  padding: 6px 10px; border: 1px solid #ced4da; border-radius: 4px;
  background: #fff; cursor: pointer; color: #495057; transition: all 0.15s;
}
.btn-reload:hover { background: #0d6efd; color: #fff; border-color: #0d6efd; }
.search-dropdown {
  position: absolute; z-index: 1000; width: 100%;
  max-height: 260px; overflow-y: auto;
  background: #fff; border: 1px solid #ced4da;
  border-top: none; border-radius: 0 0 6px 6px;
  box-shadow: 0 6px 16px rgba(0,0,0,.12);
}
.dropdown-item-custom {
  padding: 7px 10px; cursor: pointer;
  border-bottom: 1px solid #f0f0f0; font-size: 0.82rem; transition: background 0.1s;
}
.dropdown-item-custom:hover,
.dropdown-item-custom.selected { background: #e7f1ff; }
.item-code { font-weight: 700; color: #0d6efd; }
.item-sep  { color: #adb5bd; margin: 0 4px; }
.item-name { color: #343a40; }
.no-results { padding: 10px; font-size: 0.85rem; color: #6c757d; }
.selected-item {
  display: flex; align-items: center; gap: 6px;
  font-size: 0.82rem; color: #343a40;
  background: #e7f1ff; border-radius: 4px; padding: 5px 8px;
}
.search-status { font-size: 0.78rem; }
/* Calendar */
.field-label { font-weight: 600; font-size: 0.85rem; color: #495057; display: block; margin-bottom: 4px; }
.calendar-wrapper {
  background: #fff; border: 1px solid #dee2e6;
  border-radius: 6px; padding: 8px; display: inline-block;
}
.calendar-grid { display: grid; grid-template-columns: repeat(7, 30px); gap: 2px; }
.cal-header    { width: 30px; text-align: center; font-size: 0.68rem; font-weight: 700; color: #6c757d; }
.cal-cell      { width: 30px; height: 28px; display: flex; align-items: center; justify-content: center; }
.cal-btn {
  width: 28px; height: 28px; border: 1px solid #adb5bd;
  border-radius: 4px; font-size: 0.72rem; background: #fff;
  cursor: pointer; transition: all 0.12s; color: #343a40;
  box-shadow: 0 1px 2px rgba(0,0,0,.1);
}
.cal-btn:hover    { background: #e7f1ff; border-color: #0d6efd; color: #0d6efd; }
.cal-btn.selected { background: #0d6efd; border-color: #0d6efd; color: #fff; font-weight: 600; }
.cal-disabled     { font-size: 0.72rem; color: #ced4da; }
.btn-nav {
  display: flex; align-items: center; justify-content: center;
  width: 28px; height: 28px; border: 1px solid #ced4da;
  border-radius: 4px; background: #fff; cursor: pointer;
  font-size: 1rem; color: #495057; transition: all 0.12s;
}
.btn-nav:hover { background: #0d6efd; color: #fff; border-color: #0d6efd; }
.btn-quick {
  padding: 3px 10px; border: 1px solid #ced4da; border-radius: 4px;
  font-size: 0.75rem; background: #fff; cursor: pointer; color: #495057; transition: all 0.12s;
}
.btn-quick:hover { background: #f0f4ff; border-color: #0d6efd; color: #0d6efd; }
/* Action buttons */
.btn-action {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 8px 14px; border: none; border-radius: 6px;
  font-size: 0.85rem; font-weight: 600; cursor: pointer;
  transition: all 0.15s; width: 100%;
}
.btn-action.success { background: #198754; color: #fff; }
.btn-action.success:hover:not(:disabled) { background: #157347; }
.btn-action.danger  { background: #dc3545; color: #fff; }
.btn-action.danger:hover:not(:disabled)  { background: #bb2d3b; }
.btn-action.secondary { background: #fff; color: #6c757d; border: 1px solid #dee2e6; }
.btn-action.secondary:hover { background: #f8f9fa; }
.btn-action:disabled  { opacity: 0.45; cursor: not-allowed; }
@keyframes spin { to { transform: rotate(360deg); } }
.spin { display: inline-block; animation: spin 1s linear infinite; }
</style>